//
// KPIElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./kpi/KPIFillDirection";
import "./kpi/KPILabel";
import "./GraphElement";

var KPIElement = createModule("BIRD::KPIElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        maxRows: 4,
        scaleGuageSize: 2,
        rowGutter: 1,
        fillDirection: 4,
        columns: 7,
        columnGutter: 1,
        maxColumns: 4,
        graph: 1,
        maxVisuals: 4,
        labels: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default KPIElement;
